/* Apollo & Origin Smart Plus range page — progressive enhancement only.
   1. Finish pickers on the tier cards: swap image, price, link and stock line.
   2. In-page links scroll smoothly (instantly under reduced motion) and move focus.
   Without this script every card still links to the first available variant. */
(function () {
  'use strict';

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function initFinish(card) {
    if (card.dataset.bsrBound) return;
    card.dataset.bsrBound = '1';

    var image = card.querySelector('[data-bsr-variant-image]');
    var price = card.querySelector('[data-bsr-variant-price]');
    var was = card.querySelector('[data-bsr-variant-was]');
    var avail = card.querySelector('[data-bsr-variant-availability]');
    var links = card.querySelectorAll('[data-bsr-variant-link]');
    var radios = card.querySelectorAll('[data-bsr-variant]');

    Array.prototype.forEach.call(radios, function (radio) {
      radio.addEventListener('change', function () {
        if (!radio.checked) return;
        if (image && radio.dataset.image) {
          image.src = radio.dataset.image;
          image.srcset = '';
          if (radio.dataset.alt) image.alt = radio.dataset.alt;
        }
        if (price && radio.dataset.price) price.textContent = radio.dataset.price;
        if (was) {
          if (radio.dataset.was) {
            was.textContent = radio.dataset.was;
            was.hidden = false;
          } else {
            was.hidden = true;
          }
        }
        Array.prototype.forEach.call(links, function (a) {
          var base = a.dataset.base || a.getAttribute('href').split('?')[0];
          a.href = base + '?variant=' + radio.value;
        });
        if (avail) {
          var inStock = radio.dataset.available === 'true';
          avail.textContent = inStock ? avail.dataset.in : avail.dataset.out;
          avail.classList.toggle('bsr-avail--out', !inStock);
        }
      });
    });
  }

  function initScrollLinks() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bsr-scroll]'), function (link) {
      if (link.dataset.bsrScrollBound) return;
      link.dataset.bsrScrollBound = '1';
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var target = document.getElementById(href.slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', href);
        }
      });
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-bsr-finish]'), initFinish);
    initScrollLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
